// extracted by mini-css-extract-plugin
module.exports = {"slide":"services-carousel_slide__3WNV5","swiper":"services-carousel_swiper__lc2AI","initialSlide":"services-carousel_initialSlide__1OVtv"};